/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Earningspayouton2Inputs */

const en_earningspayouton2 = /** @type {(inputs: Earningspayouton2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Payout on ${i?.date}`)
};

const de_earningspayouton2 = /** @type {(inputs: Earningspayouton2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Auszahlung am ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Payout on {date}" |
*
* @param {Earningspayouton2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningspayouton2 = /** @type {((inputs: Earningspayouton2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningspayouton2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningspayouton2(inputs)
	return de_earningspayouton2(inputs)
});
export { earningspayouton2 as "earningsPayoutOn" }